import type { ProtoSupplier, SupplierContact } from '../../prototype/data/suppliers.ts'
import { proto } from '../../prototype/state/store.ts'
import { recordVersion, toastAction, writeWarehouse } from '../warehouse/actions.ts'

export const supplierActions = {
  createSupplier: (
    input: Omit<ProtoSupplier, 'id' | 'archivedAt' | 'previousNames' | 'contacts'> & {
      contacts: Omit<SupplierContact, 'id' | 'version' | 'primary'>[]
    },
  ) => toastAction(async () => (await writeWarehouse<{ id: string }>('/suppliers', input)).id),
  updateSupplier: (
    id: string,
    patch: Partial<Omit<ProtoSupplier, 'id' | 'previousNames'>>,
    version?: number,
  ) =>
    toastAction(async () => {
      await writeWarehouse(
        `/suppliers/${encodeURIComponent(id)}`,
        {
          patch,
          version: version ?? recordVersion(proto.state.suppliers.find((row) => row.id === id)),
        },
        'PATCH',
      )
      return true
    }),
  archiveSupplier: (id: string, archived: boolean) =>
    toastAction(async () => {
      await writeWarehouse(`/suppliers/${encodeURIComponent(id)}/archive`, {
        archived,
        version: recordVersion(proto.state.suppliers.find((row) => row.id === id)),
      })
      return true
    }),
  createSupplierGroup: (name: string) =>
    toastAction(() => writeWarehouse<{ id: string }>('/suppliers/groups', { name })),
  updateSupplierGroup: (id: string, name: string, version: number) =>
    toastAction(() =>
      writeWarehouse(`/suppliers/groups/${encodeURIComponent(id)}`, { name, version }, 'PATCH'),
    ),
  archiveSupplierGroup: (id: string, archived: boolean, version: number) =>
    toastAction(() =>
      writeWarehouse(`/suppliers/groups/${encodeURIComponent(id)}/archive`, {
        archived,
        version,
      }),
    ),
  addSupplierContact: (
    id: string,
    contact: {
      fullName: string
      role: string
      phone: string | null
      email: string | null
      note: string | null
    },
  ) =>
    toastAction(() =>
      writeWarehouse(`/suppliers/${encodeURIComponent(id)}/contacts`, {
        version: recordVersion(proto.state.suppliers.find((row) => row.id === id)),
        contact,
      }),
    ),
  updateSupplierContact: (
    id: string,
    personId: string,
    patch: {
      fullName?: string
      role?: string
      phone?: string | null
      email?: string | null
      note?: string | null
    },
  ) =>
    toastAction(() =>
      writeWarehouse(
        `/suppliers/${encodeURIComponent(id)}/contacts/${encodeURIComponent(personId)}`,
        {
          version: recordVersion(proto.state.suppliers.find((row) => row.id === id)),
          patch,
        },
        'PATCH',
      ),
    ),
  setPrimarySupplierContact: (id: string, personId: string) =>
    toastAction(() =>
      writeWarehouse(`/suppliers/${encodeURIComponent(id)}/primary-contact`, {
        version: recordVersion(proto.state.suppliers.find((row) => row.id === id)),
        personId,
      }),
    ),
  removeSupplierContact: (id: string, personId: string) =>
    toastAction(() =>
      writeWarehouse(`/suppliers/${encodeURIComponent(id)}/remove-contact`, {
        version: recordVersion(proto.state.suppliers.find((row) => row.id === id)),
        personId,
      }),
    ),
}
